import {ReactNode} from 'react';
import {makeStyles} from '@mui/styles';
import {Grid} from '@mui/material';
import Image from 'components/medias/Image';
import miniTablet from 'assets/images/tablets/mini_tablet.png';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 12,
    // fontWeight: 'bold',
  },
}), { name: 'ChannelLinkLabel' });

type ChannelLinkLabelProps = {
  label: ReactNode;
};

const ChannelLinkLabel = ({ label }: ChannelLinkLabelProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container className={classes.label} spacing={2} alignItems='center'>
      <Grid item>
        <Image alt="Tablette Ardoiz" src={miniTablet} />
      </Grid>
      <Grid item>
        {label}
      </Grid>
    </Grid>
  );
};

export default ChannelLinkLabel;
